module.exports = __webpack_public_path__ + "img/cmbs-chronicle-aug-30-2021-single.5ed4eca3.png";